export const getHours = () => {
  const hours = [];
  for (let i = 0; i < 24; i++) {
    hours.push(i <= 9 ? `0${i}` : String(i));
  }

  return hours;
};
